import { render, staticRenderFns } from "./EditNavigation.vue?vue&type=template&id=71dbd622&scoped=true&"
import script from "./EditNavigation.vue?vue&type=script&lang=js&"
export * from "./EditNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dbd622",
  null
  
)

export default component.exports